import { CSSObject } from '@chakra-ui/react';
import { rgba } from 'polished';

export const ModalOverlay = (theme: any): CSSObject => ({
  bg: rgba(theme.colors.gamma[800] as string, 0.7),
});
